import React from "react";
import logo from "../Assets/green.png"; // adjust path if needed

const Privacy = () => {
  const containerStyle = {
    display: "flex",
    justifyContent: "center",
    padding: "40px 20px",
  };

  const contentStyle = {
    maxWidth: "800px",
    width: "100%",
    fontFamily: "Arial, sans-serif",
  };

  const textStyle = {
    fontSize: "15px",
    lineHeight: "1.6",
    color: "#555",
  };

  const headingStyle = {
    fontSize: "20px",
    marginTop: "20px",
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <img
          src={logo}
          alt="Logo"
          style={{ width: "120px", marginBottom: "20px" }}
        />

        <h1 style={{ fontSize: "32px", marginBottom: "20px" }}>
          Privacy Policy
        </h1>

        <p style={textStyle}>
          This application does not directly collect any personal information from users.
          However, we use third-party services such as Google Ads which may collect
          certain data automatically.
        </p>

        <h2 style={headingStyle}>1. No Direct Data Collection</h2>
        <p style={textStyle}>
          We do not collect personal information such as name, email address, or
          contact details.
        </p>

        <h2 style={headingStyle}>2. Google Ads</h2>
        <p style={textStyle}>
          We use Google Ads to display advertisements. Google may use cookies,
          web beacons, or similar technologies to collect information such as
          your device, browser type, and browsing behavior to show personalized ads.
        </p>

        <h2 style={headingStyle}>3. Third-Party Privacy</h2>
        <p style={textStyle}>
          Google’s use of advertising cookies enables it and its partners to serve ads
          based on your visit to this app and other websites. Users may opt out of
          personalized advertising by visiting Google Ads Settings.
        </p>

        <h2 style={headingStyle}>4. Cookies</h2>
        <p style={textStyle}>
          Third-party vendors, including Google, use cookies to serve ads based on a
          user's prior visits to this website or other websites.
        </p>

        <h2 style={headingStyle}>5. Data Security</h2>
        <p style={textStyle}>
          We do not store personal data on our servers. Any data collected is handled
          by third-party services according to their policies.
        </p>

        <h2 style={headingStyle}>6. User Choices</h2>
        <p style={textStyle}>
          You can choose to disable cookies through your browser settings or opt out
          of personalized ads through Google Ads Settings.
        </p>

        <h2 style={headingStyle}>7. Changes to This Policy</h2>
        <p style={textStyle}>
          We may update this Privacy Policy from time to time. Any changes will be
          posted on this page.
        </p>

        <h2 style={headingStyle}>8. Contact</h2>
        <p style={textStyle}>
          If you have any questions, contact us at: info@tabsul.me
        </p>
      </div>
    </div>
  );
};

export default Privacy;